import { useEffect } from 'react';
import { applyTheme } from './components/ThemeToggle';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { I18nProvider } from './lib/i18n';
import { AuthProvider, useAuth } from './lib/auth';
import Home from './pages/Home';
import LiveRoom from './pages/LiveRoom';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import { AssistantWidget } from './components/AssistantWidget';
import HowItWorksPage from './pages/HowItWorksPage';
import ResetPassword from './pages/ResetPassword';
import AuthCallback from './pages/AuthCallback';
import Marketplace from './pages/Marketplace';
import ProductPage from './pages/ProductPage';
import Cart from './pages/Cart';
import SellerPublic from './pages/SellerPublic';
import BuyerDashboard from './pages/BuyerDashboard';
import SellerDashboard from './pages/SellerDashboard';
import AdminDashboard from './pages/AdminDashboard';
import Contact from './pages/Contact';
import About from './pages/About';
import Faq from './pages/Faq';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import { toast } from 'sonner';
import { api } from './lib/api';
import { InstallBanner } from './components/InstallBanner';
applyTheme(localStorage.getItem('ssl-theme') || 'dark');

function NotifWatcher() {
  const { user } = useAuth();
  useEffect(() => {
    if (!user) return;
    let seen = new Set();
    let first = true;
    const tick = async () => {
      try {
        const { data } = await api.get('/notifications');
        if (first) { data.forEach((n) => seen.add(n.notif_id)); first = false; return; }
        for (const n of data) {
          if (!seen.has(n.notif_id)) {
            seen.add(n.notif_id);
            if (n.type === 'outbid') toast.error(n.message);
            else if (n.type === 'won') toast.success(n.message, { duration: 6000 });
            else toast(n.message);
          }
        }
      } catch {}
    };
    tick();
    const id = setInterval(tick, 4000);
    return () => clearInterval(id);
  }, [user]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  // Emergent auth callback fragment routing
  if (location.hash?.includes('session_id=')) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/shop" element={<Marketplace />} />
      <Route path="/product/:productId" element={<ProductPage />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/live/:liveId" element={<LiveRoom />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/comment-ca-marche" element={<HowItWorksPage />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/buyer" element={<BuyerDashboard />} />
      <Route path="/seller/:sellerId" element={<SellerPublic />} />
      <Route path="/seller" element={<SellerDashboard />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/about" element={<About />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <NotifWatcher />
            <AppRouter />
            <InstallBanner />
            <AssistantWidget />
          </BrowserRouter>
          <Toaster position="top-right" theme="dark" richColors closeButton />
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
